import styles from "./FallbackBrand.module.scss";

function FallbackBrand() {
  return (
    <div className={styles.loaderContainer}>
      <svg
        className={styles.loader}
        width="120"
        height="120"
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
<path
  className={styles.bouncingBase}
  d="M25.2344 12.466H25.906C34.0496 12.466 41.2697 17.2643 44.1241 24.5417L57.3889 58.8495C58.4803 61.5686 62.5101 61.5686 63.5176 58.8495L76.7824 24.5417C79.5528 17.2643 86.8569 12.466 95.0004 12.466L68.7227 77.8028C67.3795 81.1616 63.9373 83.4008 60.1594 83.4008C56.3814 83.4008 53.0233 81.1616 51.596 77.8028L25.2344 12.466Z"
  fill="url(#paint0)"
/>


        <g className={styles.rotatingPart}>
          <path
            d="M70.5687 96.997L68.9736 93.3183L62.1733 96.0373V88.9998H58.0595V96.0373L51.2592 93.3183L49.6641 96.997L56.4644 99.6361L51.2592 104.674L54.1976 107.393L60.1584 101.795L66.0352 107.393L68.9736 104.594L63.7684 99.6361L70.5687 96.997Z"
            fill="url(#paint1)"
          />
        </g>

        <defs>
          <linearGradient id="paint0" x1="60.1235" y1="101.94" x2="60.1235" y2="25.4844" gradientUnits="userSpaceOnUse">
            <stop stopColor="#F1C441" />
            <stop offset="1" stopColor="#F1C441" />
          </linearGradient>
          <linearGradient id="paint1" x1="60.1225" y1="101.941" x2="60.1225" y2="25.4854" gradientUnits="userSpaceOnUse">
            <stop stopColor="#F1C441" />
            <stop offset="1" stopColor="#F1C441" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}

export default FallbackBrand;
